export default "__VITE_ASSET__DJDLQmJ2__"